import * as actions from "../actionTypes"

const initialState = {
    value: true,
}

export default function menu(state = initialState, action) {
    switch (action.type) {
        case actions.SET_MENU_OPEN: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
